/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import PropTypes from 'prop-types';

/**
 * Internal dependencies
 */
import EventTable from './index';
import '../../../js/blocks/bookings-schedule/style.scss';
import { IconTrendingFlat } from '../icons';
import { getReadableDateRangeString, getDateRangeTypeString } from '../../includes/date-utils';

class BookingContainer extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			offset: 0,
		};
	}

	componentDidUpdate( prevProps ) {
		if ( this.props.dateRangeType !== prevProps.dateRangeType ) {
			this.setState( { offset: 0 } );
		}
	}

	gotoPrev = ( e ) => {
		e.preventDefault();
		this.setState( { offset: parseInt( this.state.offset, 10 ) - 1 } );
	}

	gotoNext = ( e ) => {
		e.preventDefault();
		this.setState( { offset: parseInt( this.state.offset, 10 ) + 1 } );
	}

	gotoCurrent = ( e ) => {
		e.preventDefault();
		this.setState( { offset: 0 } );
	}

	onDummyClick = ( e ) => {
		e.preventDefault();
	}

	render() {
		const { dateRangeType, showDateNav } = this.props;
		const { offset } = this.state;

		const dateRangeString = getReadableDateRangeString( dateRangeType, offset );
		const dateRangeTypeString = getDateRangeTypeString( dateRangeType );

		return (
			<div>
				<div className="wc-bookings-availability-header">
					<div className="wc-bookings-availability-date">
						{ dateRangeString }
					</div>
					{ ( true === showDateNav || 'true' === showDateNav ) ? (
						<div className="wc-bookings-availability-navigation">
							{ /* eslint-disable jsx-a11y/anchor-is-valid */ }
							{ ( offset <= 0 ) ? // disable past days/weeks/months.
								<a href="#" className="wc-bookings-availability-navigation-prev wc-bookings-availability-navigation-disabled" onClick={ this.onDummyClick }>
									{ <IconTrendingFlat /> }
								</a> :
								<a href="#" className="wc-bookings-availability-navigation-prev" onClick={ this.gotoPrev }> { <IconTrendingFlat /> } </a>
							}
							<a href="#" className="wc-bookings-availability-navigation-current" onClick={ this.gotoCurrent }>{ dateRangeTypeString }</a>
							<a href="#" className="wc-bookings-availability-navigation-next" onClick={ this.gotoNext }>{ <IconTrendingFlat /> }</a>
							{ /* eslint-enable jsx-a11y/anchor-is-valid */ }
						</div>
					) : ( '' ) }
				</div>
				<EventTable { ...this.props } offset={ offset } />
			</div>
		);
	}
}

BookingContainer.propTypes = {
	dateRangeType: PropTypes.string,

	showDateNav: PropTypes.bool,
};

export default BookingContainer;
